/* eslint-disable import/prefer-default-export */
import { graphql } from 'graphql-schema';

export const GET_LEAGUE_INFO = graphql(`
  query League($id: uuid!) {
    leagues_by_pk(_id: $id) {
      _id
      program_type
    }
  }
`);
